export const getConfig = (pId: string): Config => ({
  adultAges,
  countries,
  documents: getConsents(),
  languages,
  libreSharingApiUrl: 'MOCK',
  partners: {
    [pId]: {
      displayName: 'Omnipod®',
      type: 'insulet',
      website: 'https://account-intl.omnipod.com/',
    },
  },
  supportedCountries,
  validation: {
    identity: [
      {
        code: 13,
        data: {
          key: 'min',
          regex: '(^.{12,}$)',
          value: 12,
        },
        message: 'minchar',
        products: [
          {
            name: 'polaris',
          },
        ],
        type: 'pattern',
      },
      {
        code: 15,
        data: {
          limit: 3,
        },
        message: 'repeat',
        products: [
          {
            name: 'polaris',
          },
        ],
        type: 'repeat',
      },
      {
        code: 16,
        data: {
          limit: 3,
        },
        message: 'sequential',
        products: [
          {
            name: 'polaris',
          },
        ],
        type: 'sequential',
      },
    ],
    libreApi: {
      patient: {
        firstName: {
          stringMaxLength: 40,
        },
        lastName: {
          stringMaxLength: 80,
        },
      },
    },
  },
  webviewsUrl: 'http://localhost:8080',
  zipCodePatterns: {
    FR: '^\\d{5}$',
  },
});

const adultAges = {
  AE: 18,
  AR: 18,
  AT: 18,
  AU: 18,
  BE: 18,
  BH: 18,
  BR: 18,
  CA: 18,
  CH: 18,
  CL: 18,
  CN: 18,
  CO: 18,
  CZ: 18,
  DE: 18,
  DK: 18,
  EG: 18,
  ES: 18,
  FI: 18,
  FR: 18,
  GB: 18,
  GR: 18,
  HK: 18,
  HR: 18,
  IE: 18,
  IL: 18,
  IN: 18,
  IT: 18,
  JO: 18,
  JP: 18,
  KW: 18,
  LB: 18,
  LU: 18,
  MX: 18,
  NL: 18,
  NO: 18,
  NZ: 18,
  OM: 18,
  PL: 18,
  PT: 18,
  QA: 18,
  RU: 18,
  SA: 18,
  SE: 18,
  SG: 18,
  SI: 18,
  SK: 18,
  TR: 18,
  TW: 18,
  US: 13,
  ZA: 18,
};

const countries = [
  'AF',
  'AX',
  'AL',
  'DZ',
  'AS',
  'AD',
  'AO',
  'AI',
  'AQ',
  'AG',
  'AR',
  'AM',
  'AW',
  'AU',
  'AT',
  'AZ',
  'BH',
  'BS',
  'BD',
  'BB',
  'BY',
  'BE',
  'BZ',
  'BJ',
  'BM',
  'BT',
  'BO',
  'BQ',
  'BA',
  'BW',
  'BV',
  'BR',
  'IO',
  'BN',
  'BG',
  'BF',
  'BI',
  'KH',
  'CM',
  'CA',
  'CV',
  'KY',
  'CF',
  'TD',
  'CL',
  'CN',
  'CX',
  'CC',
  'CO',
  'KM',
  'CG',
  'CD',
  'CK',
  'CR',
  'CI',
  'HR',
  'CU',
  'CW',
  'CY',
  'CZ',
  'DK',
  'DJ',
  'DM',
  'DO',
  'EC',
  'EG',
  'SV',
  'GQ',
  'ER',
  'EE',
  'ET',
  'FK',
  'FO',
  'FJ',
  'FI',
  'FR',
  'GF',
  'PF',
  'TF',
  'GA',
  'GM',
  'GE',
  'DE',
  'GH',
  'GI',
  'GR',
  'GL',
  'GD',
  'GP',
  'GU',
  'GT',
  'GG',
  'GN',
  'GW',
  'GY',
  'HT',
  'HM',
  'VA',
  'HN',
  'HK',
  'HU',
  'IS',
  'IN',
  'ID',
  'IR',
  'IQ',
  'IE',
  'IM',
  'IL',
  'IT',
  'JM',
  'JP',
  'JE',
  'JO',
  'KZ',
  'KE',
  'KI',
  'KP',
  'KR',
  'KW',
  'KG',
  'LA',
  'LV',
  'LB',
  'LS',
  'LR',
  'LY',
  'LI',
  'LT',
  'LU',
  'MO',
  'MK',
  'MG',
  'MW',
  'MY',
  'MV',
  'ML',
  'MT',
  'MH',
  'MQ',
  'MR',
  'MU',
  'YT',
  'MX',
  'FM',
  'MD',
  'MC',
  'MN',
  'ME',
  'MS',
  'MA',
  'MZ',
  'MM',
  'NA',
  'NR',
  'NP',
  'NL',
  'NC',
  'NZ',
  'NI',
  'NE',
  'NG',
  'NU',
  'NF',
  'MP',
  'NO',
  'OM',
  'PK',
  'PW',
  'PS',
  'PA',
  'PG',
  'PY',
  'PE',
  'PH',
  'PN',
  'PL',
  'PT',
  'PR',
  'QA',
  'RE',
  'RO',
  'RU',
  'RW',
  'BL',
  'SH',
  'KN',
  'LC',
  'MF',
  'PM',
  'VC',
  'WS',
  'SM',
  'ST',
  'SA',
  'SN',
  'RS',
  'SC',
  'SL',
  'SG',
  'SX',
  'SK',
  'SI',
  'SB',
  'SO',
  'ZA',
  'GS',
  'SS',
  'ES',
  'LK',
  'SD',
  'SR',
  'SJ',
  'SZ',
  'SE',
  'CH',
  'SY',
  'TW',
  'TJ',
  'TZ',
  'TH',
  'TL',
  'TG',
  'TK',
  'TO',
  'TT',
  'TN',
  'TR',
  'TM',
  'TC',
  'TV',
  'UG',
  'UA',
  'AE',
  'GB',
  'US',
  'UM',
  'UY',
  'UZ',
  'VU',
  'VE',
  'VN',
  'VG',
  'VI',
  'WF',
  'EH',
  'YE',
  'ZM',
  'ZW',
];

const languages = [
  'ar-SA',
  'cs-CZ',
  'da-DK',
  'de-DE',
  'el-GR',
  'en-GB',
  'en-US',
  'es-ES',
  'es-MX',
  'fi-FI',
  'fr-CA',
  'fr-FR',
  'he-IL',
  'hr-HR',
  'it-IT',
  'ja-JP',
  'ko-KR',
  'la-LA',
  'nb-NO',
  'nl-NL',
  'pl-PL',
  'pt-BR',
  'pt-PT',
  'ru-RU',
  'sl-SI',
  'sk-SK',
  'sv-SE',
  'tr-TR',
  'zh-TW',
];

const supportedCountries = [
  'SK',
  'AR',
  'CZ',
  'JP',
  'LU',
  'MX',
  'SG',
  'SI',
  'BR',
  'CA',
  'EG',
  'IN',
  'IT',
  'BE',
  'CH',
  'HR',
  'JO',
  'QA',
  'TR',
  'US',
  'ZA',
  'FI',
  'HK',
  'KW',
  'PL',
  'GB',
  'GR',
  'IE',
  'IL',
  'NL',
  'PT',
  'TW',
  'BH',
  'CN',
  'ES',
  'LB',
  'OM',
  'AU',
  'FR',
  'DK',
  'NO',
  'AE',
  'AT',
  'CL',
  'CO',
  'DE',
  'NZ',
  'RU',
  'SA',
  'SE',
];

const getConsents = (): Consents => {
  return {
    hipaadoc: {
      default: '',
    },
    toufsll: {
      default: '/files/documents/en-US/fsll-TOU.html',
    },
    toupat: {
      default: '',
    },
    pnpat: {
      default: '/files/documents/en-US/pat-PP.html',
    },
    hipaa: {
      default: '',
    },
  };
};
